import {
  EthereumClient,
  w3mConnectors,
  w3mProvider,
} from "@web3modal/ethereum";
import { configureChains, createConfig } from "wagmi";
const hapMainnet = {
  id: 8794598,
  name: "HAPchain",
  network: "HAPchain",
  nativeCurrency: {
    decimals: 18,
    name: "HAP",
    symbol: "HAP",
  },
  rpcUrls: {
    default: {
      http: ["https://jsonrpc.hap.land"],
    },
    public: {
      http: ["https://jsonrpc.hap.land"],
    },
  },
  blockExplorers: {
    etherscan: {
      name: "Blockscout",
      url: "https://blockscout.hap.land",
    },
    default: {
      name: "Blockscout",
      url: "https://blockscout.hap.land",
    },
  },

  testnet: true,
};
const hapTestnet = {
  id: 373737,
  name: "HAPchain testnet",
  network: "HAPchain testnet",
  nativeCurrency: {
    decimals: 18,
    name: "HAP",
    symbol: "HAP",
  },
  rpcUrls: {
    default: {
      http: ["https://jsonrpc-test.hap.land"],
    },
    public: {
      http: ["https://jsonrpc-test.hap.land"],
    },
  },
  blockExplorers: {
    etherscan: {
      name: "Blockscout",
      url: "https://blockscout-test.hap.land",
    },
    default: {
      name: "Blockscout",
      url: "https://blockscout-test.hap.land",
    },
  },

  testnet: true,
};
const IS_TESTNET = process.env.REACT_APP_IS_TESTNET === "true";
const chains = [IS_TESTNET ? hapTestnet : hapMainnet];
const projectId = process.env.REACT_APP_PROJECT_ID;
if (!projectId) {
  throw new Error("Could not find project id");
}

const { publicClient } = configureChains(chains, [w3mProvider({ projectId })]);

const wagmiClient = createConfig({
  autoConnect: true,
  connectors: w3mConnectors({
    projectId,
    chains,
  }),
  publicClient,
});
const ethereumClient = new EthereumClient(wagmiClient, chains);

export { wagmiClient, ethereumClient, projectId, chains };
